import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  giftCardIds: yup.array().of(yup.number()).required(),
});

export function useSetGiftCardsObOrderMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.setGiftCardsObOrder(), {
      ids: req.giftCardIds,
    });
  }, options);
}
